import { post } from "./client";

export type RenameReplayEntityType = "company" | "contact";

export type RenameReplayRequest = {
  entityType: RenameReplayEntityType;
  id: string;
  previousName: string;
  dryRun: boolean;
};

export type RenameReplayResponse = {
  entityType: RenameReplayEntityType;
  id: string;
  previousName: string;
  currentName: string;
  dryRun: boolean;
  rowsMatched: number;
  rowsUpdated: number;
};

export const addressBookRenameReplayService = {
  async replay(request: RenameReplayRequest): Promise<RenameReplayResponse> {
    return post<RenameReplayResponse>(
      "/v1/research/developer/fixes/replay-address-book-renames",
      request,
    );
  },
};
